import { Project as ProjectDto } from "../../../app/proxy/projects";

export class Project {
  projectId: number;
  name: string;
  contractId: number;
  contractNumber: string;
  vendorId: number;
  vendorName: string;
  propertyId: number;
  propertyName: string;
  regionName: string;
  projectOwnerId: number;
  projectOwnerName: string;
  internalOrderId: number;
  internalOrderName: string;
  internalOrderSapCode: string;
  projectTypeId: number;
  projectTypeName: string;
  projectTypeGroupId: number;
  projectTypeGroupName: string;
  supervisorId: number;
  supervisorName: string;
  harvestDate: string;
  loadDate: string;
  estimatedStartDate: string | null;
  estimatedEndDate: string | null;
  startDate: string;
  endDate: string;
  isClosed: boolean;
  relatedProjectId: number;
  baseThickness: number;
  granularThickness: number;
  totalLength: number;
  totalBudget: number;
  totalArea: number;
  totalVolume: number;
  averagePitDistance: number;
  volumetricPerformance: number;
  constructionDensity: number;
  budgetAgainstDistance: number;
  budgetAgainstVolume: number;
  progress: number;
  amountProgress: number;
  certificated: number;
  amountCertificated: number;
  totalCertificated: number;
  rowVersion: string;
  roadBO: object[] = [];

  constructor(dto: ProjectDto | Project) {
    Object.assign(this, dto);
    this.roadBO = dto.roadBO ?? [];
  }
}
